import React from "react";

import { Input, InputMessage } from "emoreg";

import { TextFieldProps } from "./types";

export const TextField = React.forwardRef<HTMLInputElement, TextFieldProps>(
  (
    {
      error,
      warning,
      helper,
      id,
      size,

      ...inputProps
    },
    ref
  ) => {
    const showError = !!error;
    const showWarning = !showError && !!warning;
    const showHelper = !showError && !showWarning && !!helper;

    const ariaDescribedBy = [
      showError && `${id}-error`,
      showWarning && `${id}-warning`,
      showHelper && `${id}-helper`,
    ]
      .filter(Boolean)
      .join(" ");

    const message = showError ? error : showWarning ? warning : helper;
    const messageVariant = showError ? "error" : showWarning ? "warning" : "helper";

    return (
      <>
        <Input
          {...inputProps}
          ref={ref}
          id={id}
          hasError={showError}
          aria-describedby={ariaDescribedBy || undefined}
          size={size}
        />

        {message && (
          <InputMessage variant={messageVariant} id={`${id}-message`}>
            {message}
          </InputMessage>
        )}
      </>
    );
  }
);

TextField.displayName = "TextField";
